module.exports = {"id":"200461","name":"Maciej Makuszewski","rating":"72","photo":"./data/images/photos/0/200461.png","club":{"name":"Lech Poznań","logo":"./data/images/clubs/LechPoznan.png"},"positions":["MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaciejMakuszewski0.json
// module id = 2652
// module chunks = 0